// ==========================================================================
// Andanza — interacciones del tema Shopify
// ==========================================================================

document.addEventListener("DOMContentLoaded", () => {

  /* ---------- Menú móvil ---------- */
  const menuToggle = document.getElementById("MenuToggle");
  const mainNav = document.getElementById("MainNav");
  if (menuToggle && mainNav) {
    menuToggle.addEventListener("click", () => {
      mainNav.classList.toggle("open");
      const open = mainNav.classList.contains("open");
      menuToggle.setAttribute("aria-expanded", open ? "true" : "false");
    });
    mainNav.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", () => mainNav.classList.remove("open"));
    });
  }

  /* ---------- Hero: si el video no carga, se muestra el fondo de respaldo ---------- */
  const heroVideo = document.querySelector(".hero-media");
  if (heroVideo && heroVideo.tagName === "VIDEO") {
    heroVideo.addEventListener("error", () => {
      heroVideo.style.display = "none";
      const hero = heroVideo.closest(".hero");
      if (hero) hero.classList.add("ph");
    });
  }

  /* ---------- Revelado suave al hacer scroll ---------- */
  const revealEls = document.querySelectorAll(".reveal");
  if ("IntersectionObserver" in window && revealEls.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("in");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );
    revealEls.forEach((el) => io.observe(el));
  } else {
    revealEls.forEach((el) => el.classList.add("in"));
  }

  /* ---------- Carro: agregar por AJAX (Sección "Fetch API" de Shopify) ---------- */
  document.querySelectorAll("[data-product-form]").forEach((form) => {
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const note = form.querySelector("[data-form-note]");
    const submitBtn = form.querySelector('button[type="submit"]');
    if (submitBtn) submitBtn.disabled = true;
    if (note) note.textContent = "";

    const formData = new FormData(form);

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        id: formData.get("id"),
        quantity: 1,
      }),
    })
      .then((res) => res.json().then((data) => ({ ok: res.ok, data })))
      .then(({ ok, data }) => {
        if (submitBtn) submitBtn.disabled = false;
        if (!ok) {
          if (note) note.textContent = data.description || "No pudimos agregar este producto.";
          return;
        }
        if (note) note.textContent = "Agregado a tu carro.";
        updateCartCount();
      })
      .catch(() => {
        if (submitBtn) submitBtn.disabled = false;
        if (note) note.textContent = "Ocurrió un error. Intenta de nuevo.";
      });
  });
});

  function updateCartCount() {
    fetch("/cart.js")
      .then((res) => res.json())
      .then((cart) => {
        document.querySelectorAll("[data-cart-count]").forEach((el) => {
          el.textContent = cart.item_count;
          el.setAttribute("data-empty", cart.item_count === 0 ? "true" : "false");
        });
      });
  }

  /* ---------- Selector de talla: marcar visualmente la opción activa ---------- */
  document.querySelectorAll(".size-options").forEach((wrap) => {
    wrap.querySelectorAll('input[type="radio"]').forEach((input) => {
      input.addEventListener("change", () => {
        wrap.querySelectorAll("label").forEach((label) => label.classList.remove("selected"));
        const label = wrap.querySelector(`label[for="${input.id}"]`);
        if (label) label.classList.add("selected");
      });
    });
  });
});
